import { UserAccessRightsGuard } from './../role/user-role/user-access-rights.guard'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LocationIndexComponent } from '../location/index/index.component'
import { TagIndexComponent } from '../tag/index/index.component'
import { ConfigurationOptionBrandingTabComponent } from './branding-tab/show.component'
import { CancellationPoliciesTabComponent } from './cancellation-policies-tab/show.component'
import { ConfigurationOptionCreateComponent } from './create/show.component'
import { ConfigurationOptionGeneralTabComponent } from './general-tab/show.component'
import { ConfigurationOptionIndexComponent } from './index/index.component'
import { MultiDayTabComponent } from './multiday-tab/show.component'
import { ConfigurationOptionInternalOperationEventsComponent } from './operation-internal-events/show.component'
import { ConfigurationOptionOrganizationTabComponent } from './organization-tab/show.component'
import { ConfigurationOptionOtherTabComponent } from './other-tab/show.component'
import { ConfigurationOptionPaymentsTabComponent } from './payments-tab/show.component'
import { ConfigurationOptionProfileTabComponent } from './profile-tab/show.component'
import { ConfigurationOptionRegistrationTabComponent } from './registration-tab/show.component'
import { ConfigurationOptionRevalidateFormTabComponent } from './revalidate-form-tab/show.component'
import { ConfigurationOptionShowComponent } from './show/show.component'
import { AccessRights } from '../role/user-role/user-role'
import { SiteSettingsComponent } from './site-settings/show.component'
import { DocumentIndexComponent } from '../document/index/index.component'
import { YearCalendarTabComponent } from './year-calendar-tab/show.component'
import { ConfigurationOptionShopPageCardComponent } from './shop-tab/shop-page-card/show.component'
import { ConfigurationOptionLoginPageCardComponent } from './login-tab/login-page-card/show.component'
import { ConfigurationOptionContactUsCardComponent } from './branding-tab/contact-us-card/show.component'
import { ConfigurationOptionMTermsConditionsCardComponent } from './branding-tab/terms-conditions-card/show.component'
import { ConfigurationOptionTagFilterTabComponent } from './tag-filter-tab/show.component'
import { ConfigurationOptionProductBrandingCardComponent } from './branding-tab/product-branding-card/product-branding-card.component'
import { ConfigurationOptionOverviewBrandingComponent } from './overview-branding/show.component'
import { ConfigurationOptionOverviewFieldAndTagsComponent } from './overview-field-tags/show.component'
import { ConfigurationOptionOverviewSettingsComponent } from './overview-settings/show.component'
import { ConfigurationOptionOnboardingComponent } from './other-tab/onboarding-card/show.component'
import { ConfigurationOptionOtherCardComponent } from './other-tab/other-card/show.component'
import { ConfigurationOptionEmployeeTabComponent } from './employee-tab/show.component'
import { ConfigurationOptionFamilyTabComponent } from './family-tab/show.component'
import { CategoryTabComponent } from './category-tab/index.component'
import { ConfigurationOptionDiscoveryAreaTabComponent } from './discovery-area-tab/show.component'
import { ConfigurationOptionScheduleSettingsTabComponent } from './schedule-settings-tab/show.component'
import { ConfigurationOptionHomePageTabComponent } from './home-page-tab/show.component'
import { environment } from 'src/environments/environment'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: ConfigurationOptionIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] }
  },
  {
    path: 'create',
    component: ConfigurationOptionCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_write] }
  },
  {
    path: 'branding',
    component: ConfigurationOptionOverviewBrandingComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] },
    children: [
      {
        path: 'branding',
        component: ConfigurationOptionBrandingTabComponent
      },
      {
        path: 'registration',
        component: ConfigurationOptionRegistrationTabComponent
      },
      {
        path: 'profile',
        component: ConfigurationOptionProfileTabComponent
      },
      {
        path: 'organization',
        component: ConfigurationOptionOrganizationTabComponent
      },
      {
        path: 'payments',
        component: ConfigurationOptionPaymentsTabComponent
      },
      {
        path: 'other',
        component: ConfigurationOptionOtherTabComponent
      },
      {
        path: 'operation-internal-events',
        component: ConfigurationOptionInternalOperationEventsComponent
      },
      {
        path: 'tags',
        component: TagIndexComponent
      },
      {
        path: 'locations',
        component: LocationIndexComponent
      },
      {
        path: 'multi-day',
        component: MultiDayTabComponent
      },
      {
        path: 'cancellation-policies',
        component: CancellationPoliciesTabComponent
      },
      {
        path: 'shop-page',
        component: ConfigurationOptionShopPageCardComponent
      },
      {
        path: 'login-page',
        component: ConfigurationOptionLoginPageCardComponent
      },
      {
        path: 'contact-page',
        component: ConfigurationOptionContactUsCardComponent
      },
      {
        path: 'terms-and-conditions',
        component: ConfigurationOptionMTermsConditionsCardComponent
      },
      {
        path: 'categories',
        component: CategoryTabComponent
      },
      {
        path: 'filter-tag',
        component: ConfigurationOptionTagFilterTabComponent
      },
      {
        path: 'category-description',
        component: CategoryTabComponent
      },
      {
        path: 'year-calendar',
        component: YearCalendarTabComponent
      },
      {
        path: 'denominations',
        component: ConfigurationOptionProductBrandingCardComponent
      }
    ]
  },
  {
    path: 'site-settings',
    component: SiteSettingsComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] },
    children: [
      {
        path: 'category-description',
        component: CategoryTabComponent
      }
    ]
  },
  {
    path: 'filter-tags',
    component: ConfigurationOptionOverviewFieldAndTagsComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] },
    children: [
      {
        path: 'registration',
        component: ConfigurationOptionRegistrationTabComponent
      },
      ...(environment.moduleConfigs.configOptionModule.showRevalidateFormTab
        ? [
            {
              path: 'revalidate-form',
              component: ConfigurationOptionRevalidateFormTabComponent
            }
          ]
        : []),
      {
        path: 'profile',
        component: ConfigurationOptionProfileTabComponent
      },
      {
        path: 'organization',
        component: ConfigurationOptionOrganizationTabComponent
      },
      {
        path: 'payments',
        component: ConfigurationOptionPaymentsTabComponent
      },
      {
        path: 'other',
        component: ConfigurationOptionOtherTabComponent
      },
      {
        path: 'operation-internal-events',
        component: ConfigurationOptionInternalOperationEventsComponent
      },
      {
        path: 'tags',
        component: TagIndexComponent
      },
      {
        path: 'locations',
        component: LocationIndexComponent
      },
      {
        path: 'multi-day',
        component: MultiDayTabComponent
      },
      {
        path: 'cancellation-policies',
        component: CancellationPoliciesTabComponent
      },
      {
        path: 'shop-page',
        component: ConfigurationOptionShopPageCardComponent
      },
      {
        path: 'login-page',
        component: ConfigurationOptionLoginPageCardComponent
      },
      {
        path: 'contact-page',
        component: ConfigurationOptionContactUsCardComponent
      },
      {
        path: 'terms-and-conditions',
        component: ConfigurationOptionMTermsConditionsCardComponent
      },
      {
        path: 'categories',
        component: CategoryTabComponent
      },
      {
        path: 'filter-tag',
        component: ConfigurationOptionTagFilterTabComponent
      },
      {
        path: 'category-description',
        component: CategoryTabComponent
      },
      {
        path: 'year-calendar',
        component: YearCalendarTabComponent
      },
      {
        path: 'denominations',
        component: ConfigurationOptionProductBrandingCardComponent
      }
    ]
  },
  {
    path: 'settings',
    component: ConfigurationOptionOverviewSettingsComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] },
    children: [
      {
        path: 'registration',
        component: ConfigurationOptionRegistrationTabComponent
      },
      {
        path: 'profile',
        component: ConfigurationOptionProfileTabComponent
      },
      {
        path: 'organization',
        component: ConfigurationOptionOrganizationTabComponent
      },
      {
        path: 'payments',
        component: ConfigurationOptionPaymentsTabComponent
      },
      {
        path: 'other',
        component: ConfigurationOptionOtherTabComponent
      },
      {
        path: 'operation-internal-events',
        component: ConfigurationOptionInternalOperationEventsComponent
      },
      {
        path: 'tags',
        component: TagIndexComponent
      },
      {
        path: 'locations',
        component: LocationIndexComponent
      },
      {
        path: 'multi-day',
        component: MultiDayTabComponent
      },
      {
        path: 'cancellation-policies',
        component: CancellationPoliciesTabComponent
      },
      {
        path: 'shop-page',
        component: ConfigurationOptionShopPageCardComponent
      },
      {
        path: 'login-page',
        component: ConfigurationOptionLoginPageCardComponent
      },
      {
        path: 'contact-page',
        component: ConfigurationOptionContactUsCardComponent
      },
      {
        path: 'terms-and-conditions',
        component: ConfigurationOptionMTermsConditionsCardComponent
      },
      {
        path: 'categories',
        component: CategoryTabComponent
      },
      {
        path: 'filter-tag',
        component: ConfigurationOptionTagFilterTabComponent
      },
      {
        path: 'category-description',
        component: CategoryTabComponent
      },
      {
        path: 'year-calendar',
        component: YearCalendarTabComponent
      },
      {
        path: 'denominations',
        component: ConfigurationOptionProductBrandingCardComponent
      },
      {
        path: 'employee',
        component: ConfigurationOptionEmployeeTabComponent
      },
      {
        path: 'family',
        component: ConfigurationOptionFamilyTabComponent
      },
      {
        path: 'discovery-area',
        component: ConfigurationOptionDiscoveryAreaTabComponent
      },
      {
        path: 'schedule',
        component: ConfigurationOptionScheduleSettingsTabComponent
      },
      ...(environment.moduleConfigs.configOptionModule.showHomePageSettings
        ? [
            {
              path: 'home-page',
              component: ConfigurationOptionHomePageTabComponent
            }
          ]
        : []),
      {
        path: 'other',
        component: ConfigurationOptionOtherCardComponent
      },
      {
        path: 'onboarding',
        component: ConfigurationOptionOnboardingComponent
      }
    ]
  },
  {
    path: 'documents',
    component: DocumentIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] }
  },
  {
    path: ':configurationOptionId',
    component: ConfigurationOptionShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.ConfigurationOptions_read] },
    children: [
      {
        path: '',
        component: ConfigurationOptionGeneralTabComponent,
        pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigurationOptionRoutingModule {}
